import { AfterViewInit, Component, OnInit } from '@angular/core'; // Removed AfterViewInit
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { UserProfileService } from '@src/app/core/services/userprofile.service'; // Added UserProfileService
import { Subscription } from '@src/app/models/subscription';
import { UserProfile } from '@src/app/models/userProfile'; // Assuming UserProfile model exists
import { Router } from '@angular/router';

@Component({
  selector: 'tlp-pricing-stripe',
  templateUrl: './pricing-stripe.component.html',
  styleUrls: ['./pricing-stripe.component.css']
})
export class PricingStripeComponent implements OnInit,  AfterViewInit { // Removed AfterViewInit
  public subscription: Subscription = new Subscription();
  public userProfile: UserProfile | null = null; // Added userProfile property
  public stripeSessionUrl: string = '/'; 

  constructor(
    private readonly subscriptionService: SubscriptionService,
    private readonly userProfileService: UserProfileService,
    private readonly router: Router 
  ) {}

  ngOnInit() {
    // Fetch subscription
    this.subscriptionService.getCurrentPlan().subscribe({
      next: (subscription) => {
        this.subscription = subscription;
      },
      error: (error) => {
        console.error('Error fetching subscription:', error);
        // this.toastr.error(error, 'An error has occured fetching subscription:');
      },
    });

    
    // Fetch subscription
    this.subscriptionService.getStripeSession().subscribe({
      next: (session) => {
        console.log(session);
        this.stripeSessionUrl = session.url;
      },
      error: (error) => {
        console.error('Error creating the stripe session subscription:', error);
      },
    });

    // Fetch user profile
    this.userProfileService.getMyProfile().subscribe({ // Corrected method name
      next: (profile: UserProfile) => { // Added UserProfile type
        this.userProfile = profile;
      },
      error: (error: any) => { // Added type for error
        console.error('Error fetching user profile:', error);
        // this.toastr.error(error, 'An error has occured fetching profile:');
      },
    });
  }

  onSubscribeClick(newPlan: string){
    document.location.href = this.stripeSessionUrl;
  }

  ngAfterViewInit() {
    return;
    //Wait for the document to load and the Stripe element to render
    setTimeout(() => {
      const pricingTables = document.querySelectorAll('button');
      pricingTables.forEach((table) => {
        // Wait for Stripe Pricing Table to render its content
        table.addEventListener('click', (event) => {
          
              event.preventDefault();
              console.log('Subscribe button clicked');
              document.location.href = this.stripeSessionUrl;
              
            });
          })
        }, 2000); // Adjust timing as needed
  }
}
